// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"58ae5bcb","977":"52ba0cf9"}[chunkId] + ".chunk.js";
};